<ion-grid [ngClass]="options.styleClasses.join(' ')" #contenttable>
  <!-- Header Mobilny -->
  <ng-container *ngIf="mobileView && !options.hideMobileHeader">
    <div
      [ngClass]="
        'mobile-header' + (options.mainStyle ? '-' + options.mainStyle : '')
      "
    >
      <div
        *ngIf="!options.hideMobileCounter"
      
      >
        <ion-text class="text-info">
          {{
            rowsLoader.getRowsCount()
              | translateCount: options.overrideCountTranslation
          }}
        </ion-text>
      </div>
      <div class="selectable" *ngIf="sortPossibles?.length > 0">
        <ion-label
          class="sort-text"
          [ngClass]="{ 'sort-text--with-filter': options.mobileFilterButton }"
          (click)="showSort()"
        >
          {{
            currentSortDisplay?.length > 0
              ? currentSortDisplay
              : ("SORT" | translate)
          }}
        </ion-label>
      </div>
      <div *ngIf="!options.wideMobileAddButtonText && options.permissionSpaceAdd ">
        <ion-button
          color="secondary"
          *ngIf="options.permissionEdit && options.headerAddLink"
          routerLink="{{ options.headerAddLink }}"
          size="small"
          class="pagination-client-side__mobile-add-button"
        >
          <ion-icon name="add" size="medium"></ion-icon>
          <ion-label>{{ "ADD" | translate }}</ion-label>
        </ion-button>

        <ion-button
          class="pagination-client-side__mobile-add-button"
          color="secondary"
          *ngIf="options.permissionEdit && options.headerEmitClick"
          (click)="onHeaderEmitClick()"
          size="small"
        >
          <ion-icon slot="icon-only" name="add" size="medium"></ion-icon>
        </ion-button>
      </div>
    </div>
    <div *ngIf="options.wideMobileAddButtonText?.length > 0 && options.permissionSpaceAdd ">
      <ion-button
        *ngIf="options.permissionEdit && options.headerAddLink"
        routerLink="{{ options.headerAddLink }}"
        expand="full"
        fill="solid"
        shape="round"
        color="light"
        class="pagination-client-side__mobile-wide-add-button"
      >
        {{ options.wideMobileAddButtonText | translate }}
      </ion-button>
      <ion-button
        *ngIf="options.permissionEdit && options.headerEmitClick"
        (click)="onHeaderEmitClick()"
        expand="full"
        fill="solid"
        shape="round"
        color="light"
        class="pagination-client-side__mobile-wide-add-button"
      >
        {{ options.wideMobileAddButtonText | translate }}
      </ion-button>
    </div>
  </ng-container>
  <!-- Header Desktop -->
  <ion-row
    *ngIf="columns && columns.length > 0 && !mobileView"
    class="header"
    [ngClass]="{ 'header--sticky': options.headerStickyPosition != 'disabled' }"
    [style.top.px]="
      options.headerStickyPosition != 'disabled'
        ? options.headerStickyPosition
        : ''
    "
    align-items-center
  >
    <ion-col
      *ngFor="let column of columns"
      size="{{ column.size }}"
      [attr.size-xl]="column.sizeXl ? column.sizeXl : null"
      [attr.size-lg]="column.sizeLg ? column.sizeLg : null"
      [attr.size-md]="column.sizeMd ? column.sizeMd : null"
      [ngClass]="{ 'col-center': column.center }"
    >
      <div>
        {{ column.displayName | translate }}
      </div>

      <div *ngIf="column.sortable" class="sort-icon-container">
        <ion-icon
          [ngClass]="
            'sort-icon' +
            (currentSortColumn == column.name && currentSortDir == ascSort
              ? ' sort-icon-current'
              : '')
          "
          (click)="changeSort(column.name, ascSort)"
          name="caret-up-outline"
        ></ion-icon>

        <ion-icon
          [ngClass]="
            'sort-icon' +
            (currentSortColumn == column.name && currentSortDir == descSort
              ? ' sort-icon-current'
              : '')
          "
          (click)="changeSort(column.name, descSort)"
          name="caret-down-outline"
        ></ion-icon>
      </div>
      <div class="sort-icon-container" *ngIf="column.info">
        <ion-button
          (click)="onShowInfo($event, column.info)"
          fill="clear"
          shape="round"
          size="small"
        >
          <ion-icon
            slot="icon-only"
            src="../../../../assets/icons/info.svg"
          ></ion-icon>
        </ion-button>
      </div>
    </ion-col>

    <ion-col
      *ngIf="
        options.permissionSpaceAdd &&
        (options.headerAddLink ||
          options.removeElementAction ||
          options.headerEmitClick)
      "
      class="add-remove-col"
      size="{{ options.headerAddRemoveColSize }}"
    >
      <ion-button
        type="add"
        *ngIf="options.headerAddLink"
        routerLink="{{ options.headerAddLink }}"
        size="medium"
      >
        <ion-icon name="add" size="medium"></ion-icon>
      </ion-button>

      <ion-button
        type="add"
        *ngIf="options.headerEmitClick"
        (click)="onHeaderEmitClick()"
        size="medium"
      >
        <ion-icon name="add" size="medium"></ion-icon>
      </ion-button>
    </ion-col>
  </ion-row>

  <ng-container *ngIf="components.length">
    <ion-text color="dark" *ngIf="options.subheaderText">
      <h6
        class="pagination-client-side__subheader {{
          options.subheaderCssClass
        }}"
        (click)="toggleList()"
      >
        <span class="margin-right-8">
          {{ options.subheaderText }}
        </span>

        <ion-icon
          class="header-title-arrow"
          size="small"
          name="chevron-up-outline"
          [@toggleRotate]="listSlidedDown ? 'inactive' : 'active'"
        ></ion-icon>
      </h6>
    </ion-text>
  </ng-container>

  <no-result
    *ngIf="!options.hideNoResultInfo"
    [collection]="components"
    [text]="options.noResultsText"
    [addLink]="options.noResultsAddLink"
    [addButtonText]="options.addButtonText"
    [permissionAdd]="options.permissionAdd"
    class="no-results-small-margin"
  ></no-result>

  <!-- Rows container mobile (Dynamic) -->

  <div
    *ngIf="!options.showLoader"
    [@toggleHeight]="listSlidedDown ? 'active' : 'inactive'"
    [ngClass]="{ 'overflow-hidden': !listSlidedDown }"
  >
    <ng-container *ngIf="componentRef" #rowTemplate></ng-container>
  </div>

  <div
    *ngIf="options.showLoader"
    [@toggleHeight]="
      rowsLoader.rowsVisible?.length !== 0 ? 'active' : 'inactive'
    "
    class="overflow-hidden"
  >
    <ng-container *ngIf="componentRef" #rowTemplate></ng-container>
  </div>
  <!-- Rows container Desktop -->

  <ng-container *ngIf="!componentRef">
    <ion-row class="content" *ngFor="let _row of rowsLoader.rowsVisible">
      <ion-col
        *ngFor="let column of columns"
        size="{{ column.size }}"
        (click)="navigateToElement(_row.id)"
      >
        {{
          column.colValueDisplay
            ? column.colValueDisplay(_row)
            : _row[column.name]
        }}
      </ion-col>
      <ion-col
        class="add-remove-col"
        *ngIf="
          options.permissionEdit &&
          (options.headerAddLink || options.removeElementAction)
        "
        size="{{ options.headerAddRemoveColSize }}"
      >
        <ion-button
          type="close"
          *ngIf="options.removeElementAction"
          size="medium"
          (click)="removeAction(_row.id)"
        >
          <ion-icon name="close" size="medium"></ion-icon>
        </ion-button>
      </ion-col>
      <ion-col *ngIf="options.actionButton.length > 0">
        <ion-button size="small">
          <ion-icon name="add" size="medium"></ion-icon>
          <ion-label>{{ options.actionButton }}</ion-label>
        </ion-button>
      </ion-col>
    </ion-row>
  </ng-container>

  <ion-infinite-scroll
    *ngIf="!rowsLoader.allRowsVisible && rowsLoader.rowsVisible?.length !== 0"
    (ionInfinite)="loadRows($event)"
  >
    <ion-infinite-scroll-content
      loadingSpinner="bubbles"
      loadingText="{{ 'INFINITE_LOADER_INFO_TEXT' | translate }}"
    >
    </ion-infinite-scroll-content>
  </ion-infinite-scroll>
</ion-grid>
